enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
}

const LEVEL_NAMES: Record<LogLevel, string> = {
  [LogLevel.DEBUG]: 'DEBUG',
  [LogLevel.INFO]: 'INFO',
  [LogLevel.WARN]: 'WARN',
  [LogLevel.ERROR]: 'ERROR',
}

const LEVEL_STYLES: Record<LogLevel, string> = {
  [LogLevel.DEBUG]: 'color: #6c757d',
  [LogLevel.INFO]: 'color: #28a745',
  [LogLevel.WARN]: 'color: #ffc107',
  [LogLevel.ERROR]: 'color: #dc3545; font-weight: bold',
}

const IS_DEV = process.env.NODE_ENV === 'development'
const MIN_LEVEL = IS_DEV ? LogLevel.DEBUG : LogLevel.WARN

class Logger {
  private module: string
  private user?: string

  constructor(module: string, user?: string) {
    this.module = module
    this.user = user
  }

  withUser(user: string): Logger {
    return new Logger(this.module, user)
  }

  withModule(module: string): Logger {
    return new Logger(module, this.user)
  }

  private log(level: LogLevel, message: string, data?: any) {
    if (level < MIN_LEVEL) return

    const ts = new Date().toISOString().slice(11, 23)
    const lvl = LEVEL_NAMES[level]
    const userTag = this.user ? ` [${this.user}]` : ''
    const prefix = `%c${ts} ${lvl} [${this.module}]${userTag}`
    const style = LEVEL_STYLES[level]

    if (level === LogLevel.ERROR) {
      data !== undefined ? console.error(prefix, style, message, data) : console.error(prefix, style, message)
    } else if (level === LogLevel.WARN) {
      data !== undefined ? console.warn(prefix, style, message, data) : console.warn(prefix, style, message)
    } else {
      data !== undefined ? console.log(prefix, style, message, data) : console.log(prefix, style, message)
    }
  }

  debug(message: string, data?: any) { this.log(LogLevel.DEBUG, message, data) }
  info(message: string, data?: any) { this.log(LogLevel.INFO, message, data) }
  warn(message: string, data?: any) { this.log(LogLevel.WARN, message, data) }
  error(message: string, data?: any) { this.log(LogLevel.ERROR, message, data) }
}

export function createLogger(module: string): Logger {
  return new Logger(module)
}

export const log = createLogger('app')
